module.exports = __webpack_public_path__ + "media/high-sound.710f4441.wav";